import React from 'react';
import "./Login.css";
/* import emailIcon from '../assets/icons_assets/New Folder With Items/emailIcon.png';
import lockIcon from '../assets/icons_assets/New Folder With Items/lockIcon.png'; */
/* import nameIcon from '../assets/icons_assets/New Folder With Items/nameIcon.png';  */
/* import Signup from './Signup'; */
import { Signup } from './Signup';
import { LoginL } from './LoginL';


function Login() {
const [currentForm, setCurrentForm] = React.useState('login');

const toggleForm = (formName) => {
  setCurrentForm(formName);
}

return(

  <div className='registration'>
    {currentForm === "login" ? <LoginL onFormSwitch={toggleForm}/> : <Signup onFormSwitch={toggleForm}/>}
  </div>

);
}

export default Login;